import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { FC } from "react";

const ButtonDownloadPDF: FC = () => {
    const handleDownloadPDF = () => {
        window.print();
    };

    return (
        <div className="">
            <button
                type="button"
                className="py-2 px-4 
                shadow-[0px_3px_6px_0px_rgba(0,0,0,0.08)] 
                rounded-[7px] 
                flex 
                text-[#005FF9] 
                font-['Montserrat'] 
                leading-5 
                not-italic 
                font-bold 
                text-[14px] 
                underline"
                onClick={handleDownloadPDF}
            >
                <ArrowDownTrayIcon
                    className='w-[1.3rem] mr-1 text-[#005FF9] font-bold cursor-pointer'
                /> Download PDF
            </button>
        </div>
    );
};

export default ButtonDownloadPDF;